---
label: Sequence Viewer
category: sequences
icon: FileTextIcon
keywords: [sequence, viewer, genome, dna, rna, protein, edit, annotate]
addedInVersion: "0.0.0"
---

# Sequence Viewer

View and edit individual sequences.

More documentation coming soon.

## Traces

Import an AB1 file to view its Sanger sequencing trace alongside the sequence.
The trace and quality score tracks appear automatically in the viewer and can be
toggled on or off in the track manager.
